import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { Channel } from './channel';

/**
 * Configuration for a Notification task.
 * Sends messages through one or more configured channels (currently: Email).
 * Each channel is processed independently; disabled channels are skipped.
 */
export class NotificationConfig extends DestinationTaskConfigBase {
	/** Array of notification channel configurations. @default [] */
	channels: Channel[] = [];

	constructor(init?: Partial<NotificationConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
